module.exports = __webpack_public_path__ + "src/assets/games/20/6.jpg";